import { Fragment, useMemo } from "react";

import EvalRunReportModelRankings from "./EvalRunReportModelRankings";

export default EvalRunReportSummary;

function EvalRunReportSummary(props) {
  const { summary, modelRankings } = props;
  return (
    <div className="flex flex-col flex-1 gap-y-4 max-w-5xl">
      <div className="space-y-4">
        <p className="text-sm font-semibold">Summary</p>
        <div className="space-y-3 text-sm text-gray-700">
          <RichText text={summary} />
        </div>
      </div>

      <EvalRunReportModelRankings modelRankings={modelRankings} />
    </div>
  );
}

/**
 * The evaluator writes its summary in markdown, so rendering it as a plain
 * string left literal `**asterisks**` on screen.
 *
 * Handles the small subset the model actually emits — paragraph breaks and
 * `**bold**` — by building React nodes rather than setting innerHTML, so LLM
 * output can never inject markup.
 */
function RichText(props) {
  const { text } = props;

  const paragraphs = useMemo(() => {
    if (!text) return [];
    return String(text)
      .split(/\n\s*\n/)
      .map((block) => block.trim())
      .filter(Boolean);
  }, [text]);

  if (paragraphs.length === 0) {
    return <p className="text-gray-400">No summary was generated.</p>;
  }

  return (
    <>
      {paragraphs.map((paragraph, idx) => (
        <p key={idx}>{renderBold(paragraph)}</p>
      ))}
    </>
  );
}

function renderBold(paragraph: string) {
  // Odd indexes are the segments that sat between a pair of ** markers.
  const segments = paragraph.split("**");

  return segments.map((segment, idx) =>
    idx % 2 === 1 ? (
      <strong key={idx} className="font-semibold text-gray-900">
        {segment}
      </strong>
    ) : (
      <Fragment key={idx}>{segment}</Fragment>
    ),
  );
}
